import { useQuery } from '@gogame/query';

import * as CONCEPT from 'scenes/Gallery/GalleryPage/Concepts/constants';
import { loadConceptDetails } from 'scenes/Gallery/GalleryPage/Concepts/sources/concepts';
import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/constants';
import { loadCreative } from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';

import { original } from './queryKeyFactory';

export const useConceptOriginal = ({ id }, settings) => {
  return useQuery(
    original(id),
    async (_, { signal }) => {
      const conceptDetails = await loadConceptDetails({ id }, { signal });
      return loadCreative(
        { id: conceptDetails[CONCEPT.ORIGINAL][CREATIVE.ID] },
        { signal }
      );
    },
    settings
  );
};
